export type AccountIdentifier = { kind: string; hint: string; value?: string };

export function identifierLabel(kind: string) {
  return ({ username: '用户名', phone: '手机号', email: '邮箱' } as Record<string, string>)[kind] ?? kind;
}

export function identifierText(identifier: AccountIdentifier) {
  return identifier.kind === 'username' ? identifier.value ?? identifier.hint : identifier.hint;
}

export function AccountIdentifiers({ identifiers }: { identifiers: AccountIdentifier[] }) {
  if (!identifiers.length) return <small>未绑定登录身份</small>;
  return <>{[...identifiers].sort((a, b) => Number(b.kind === 'username') - Number(a.kind === 'username')).map(id =>
    <small key={`${id.kind}-${id.hint}`}>{identifierLabel(id.kind)} · {identifierText(id)}</small>
  )}</>;
}

const accountDateFormatter = new Intl.DateTimeFormat('zh-CN', {
  timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
});

export function AccountTime({ value, empty = '未记录' }: { value: string | null | undefined; empty?: string }) {
  if (!value || Number.isNaN(Date.parse(value))) return <span>{empty}</span>;
  return <time dateTime={value} title="北京时间（UTC+8）">{accountDateFormatter.format(new Date(value))}</time>;
}
